<template>
  <div class="confirm">
    <div @click="confirm" class="confirm-wrapper">
      <slot></slot>
    </div>
    <div v-if="!showNative">
      <b-modal :id="id" :title="title" v-bind="modalOptions" @ok="emitOk" @cancel="emitCancel">
        <p class="my-4">{{ message }}</p>
        <template #modal-ok>{{ buttonOk }}</template>
        <template #modal-cancel>{{ buttonCancel }}</template>
      </b-modal>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: { type: String, required: true },
    message: { type: String, required: true },
    title: { type: String, default: null },
    buttonOk: { type: String, default: 'OK' },
    buttonCancel: { type: String, default: 'Abbrechen' },
    modalOptions: { type: Object, default: () => ({})}
  },

  emits: ['ok', 'cancel'],

  setup({ message, title, buttonOk, buttonCancel }, { emit }) {
    const showNative = window.isCordova()

    const emitOk = () => emit('ok')
    const emitCancel = () => emit('cancel')

    const confirm = () => {
      if (showNative) {
        navigator.notification.confirm(
          message,
          (buttonIndex) => {
            if (buttonIndex === 1) {
              emitOk()
            } else {
              emitCancel()
            }
          },
          title,
          [ buttonOk, buttonCancel ]
        )
      }
    }

    return {
      showNative,
      confirm,
      emitOk,
      emitCancel,
    }
  }
}
</script>

<style lang="scss">
.confirm-wrapper {
  display: inline;
}
</style>
